var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 2 16 10",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.2 7.8l6.6 6.6c.2.2.6.3.9.2.3-.1.5-.4.5-.6V9.1h12.4c1 0 1.9-.8 1.9-1.9s-.8-1.9-1.9-1.9H8.2V.7c0-.3-.3-.5-.5-.6-.1-.1-.3-.1-.3-.1-.2 0-.4.1-.6.2L.2 6.8c-.3.3-.3.7 0 1z",
    fill: "#5D5D5D"
  })));
}

export default SvgIconBack;